import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import useSWR from "swr";
import { getJunctionsControllerGetVehicleCountsV0Url, junctionsControllerGetVehicleCountsV0 } from "../generated/endpoints/junctions/junctions";
import type { JunctionMovementCountsDto } from "../generated/models/junctionMovementCountsDto";
import type { TrajectoryPointDtoVehicleType } from "../generated/models/trajectoryPointDtoVehicleType";
import { ApiResponse } from "@/types/apiResponse";
export const useJunctionVehicleCounts = (junctionId, t0) => {
  const $ = _c(13);
  const {
    vehicleTypes,
    startTimestamp,
    endTimestamp
  } = t0;
  let t1;
  if ($[0] !== vehicleTypes) {
    t1 = vehicleTypes.join(",");
    $[0] = vehicleTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const vehicleTypesKey = t1;
  let t2;
  bb0: {
    if (junctionId === null || startTimestamp === null || endTimestamp === null) {
      t2 = null;
      break bb0;
    }
    const t3 = vehicleTypesKey.length > 0 ? vehicleTypesKey : undefined;
    let t4;
    if ($[2] !== endTimestamp || $[3] !== startTimestamp || $[4] !== t3) {
      t4 = {
        vehicleTypes: t3,
        startTimestamp,
        endTimestamp
      };
      $[2] = endTimestamp;
      $[3] = startTimestamp;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t2 = t4;
  }
  const params = t2;
  let t3;
  if ($[6] !== junctionId || $[7] !== params) {
    t3 = params === null ? null : getJunctionsControllerGetVehicleCountsV0Url(junctionId, params);
    $[6] = junctionId;
    $[7] = params;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const swrKey = t3;
  let t4;
  if ($[9] !== junctionId || $[10] !== params) {
    t4 = () => junctionsControllerGetVehicleCountsV0(junctionId, params);
    $[9] = junctionId;
    $[10] = params;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      keepPreviousData: true
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return useSWR(swrKey, t4, t5);
};